import React from "react";
import WArticleContent from "../components/ArticlePage";

const ArticlePageWeb = () => {

    return(
        <WArticleContent />
    )
}

export default ArticlePageWeb;